import { DepositAddress } from '@cakedefi/cake-sdk';

const CUSTOM_TAGS_REQUIRED: Record<
  keyof Pick<DepositAddress, 'memoId' | 'destinationTag'>,
  {
    key: keyof Pick<DepositAddress, 'memoId' | 'destinationTag'>;
    name: string;
    question: string;
  }
> = {
  memoId: {
    key: 'memoId',
    name: 'Memo Id',
    question: 'action__depositQuestionsScreen__confirmation4',
  },
  destinationTag: {
    key: 'destinationTag',
    name: 'Destination Tag',
    question: 'action__depositQuestionsScreen__confirmation4_destinationTag',
  },
};

const getAddressCustomTag = (data?: DepositAddress) => Object.entries(CUSTOM_TAGS_REQUIRED).find(
  ([key]) => data && key in data && !!data[key as keyof DepositAddress],
)?.[1];

export default getAddressCustomTag;
